import { Locale, languages } from "./interfaces/language";

export const i18nConfig = {
  locales: languages,
  defaultLocale: Locale.EN_US,
};
